// extracted by mini-css-extract-plugin
var _1 = "MessageBubbleController__fadeIn--O7kU2";
var _2 = "MessageBubbleController__fadeInActive--omAkS";
var _3 = "MessageBubbleController__fadeOut--odazZ";
var _4 = "MessageBubbleController__fadeOutActive--YFL9Q";
export { _1 as "fadeIn", _2 as "fadeInActive", _3 as "fadeOut", _4 as "fadeOutActive" }
